import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ReactNode, useState } from 'react'
import Collapsible from 'react-collapsible'
import { Spinner } from './Spinner'

interface Props {
  title: string
  open?: boolean
  isLoading?: boolean
  children: ReactNode
}

export function CollapsibleSection({ title, open = true, isLoading = false, children }: Props) {
  const [isOpen, setIsOpen] = useState(open)

  const className = `${tailwind.header} ${isOpen ? 'bg-[#555]' : 'bg-[#777]'}`
  const titleBar = (
    <>
      <div className={tailwind.title}>{title}</div>
      <div className={tailwind.row}>
        <div className={tailwind.spinner}>{isLoading ? <Spinner size={25} color={'white'} /> : null}</div>
        <div className={tailwind.icon}>
          {isOpen ? <FontAwesomeIcon icon={faMinus} /> : <FontAwesomeIcon icon={faPlus} />}
        </div>
      </div>
    </>
  )

  return (
    <div className={tailwind.section}>
      <Collapsible
        trigger={titleBar}
        triggerClassName={className}
        triggerOpenedClassName={className}
        transitionTime={100}
        open={open}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
      >
        <div>
          {children}
          <div className={tailwind.spacing} />
        </div>
      </Collapsible>
    </div>
  )
}

const tailwind = {
  header: 'flex flex-row text-white text-l font-bold py-0.5 pl-4 pr-1 h-10',
  title: 'w-full pt-1.5',
  spacing: 'h-1',
  section: 'mb-0',
  spinner: 'pt-1.5 pr-3 w-10',
  row: 'flex flex-row',
  icon: 'h-10 px-2 pt-1.5',
}
